import React from 'react';
import NeonDivider from './NeonDivider';

export const PrivacyModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose}></div>
        
        <div className="relative w-full max-w-4xl bg-black/90 border border-neonBlue/30 rounded-xl p-8 max-h-[80vh] overflow-y-auto">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-3xl md:text-4xl font-logoSans text-ivory">
              PRIVACY POLICY
            </h2>
            <button
              onClick={onClose}
              className="text-gray hover:text-ivory transition-colors duration-200 p-2"
              aria-label="Close modal"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <NeonDivider color="neonBlue" />
          
          <div className="prose prose-invert max-w-none">
            <div className="space-y-8 text-gray">
              <div>
                <h3 className="text-xl font-logoSans text-ivory mb-4">Information We Collect</h3>
                <p className="leading-relaxed">
                  Billy's WingCo collects information you provide directly to us, such as when you make a reservation, 
                  place an order, sign up for our newsletter, or contact us for support.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-logoSans text-ivory mb-4">How We Use Your Information</h3>
                <ul className="space-y-2 leading-relaxed">
                  <li>• Process and fulfill your orders</li>
                  <li>• Send you promotional communications (with your consent)</li>
                  <li>• Improve our services and customer experience</li>
                  <li>• Comply with legal obligations</li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-xl font-logoSans text-ivory mb-4">Information Sharing</h3>
                <p className="leading-relaxed">
                  We do not sell, trade, or rent your personal information to third parties. We may share your 
                  information only as necessary to provide our services or as required by law.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-logoSans text-ivory mb-4">Contact Us</h3>
                <p className="leading-relaxed">
                  If you have any questions about this Privacy Policy, please contact us at 
                  <span className="text-neonBlue"> privacy@billyswingco.com</span> or 
                  <span className="text-neonBlue"> (416) 265-9223</span>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const TermsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose}></div>
        
        <div className="relative w-full max-w-4xl bg-black/90 border border-neonRed/30 rounded-xl p-8 max-h-[80vh] overflow-y-auto">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-3xl md:text-4xl font-logoSans text-ivory">
              TERMS OF SERVICE
            </h2>
            <button
              onClick={onClose}
              className="text-gray hover:text-ivory transition-colors duration-200 p-2"
              aria-label="Close modal"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <NeonDivider color="neonRed" />
          
          <div className="prose prose-invert max-w-none">
            <div className="space-y-8 text-gray">
              <div>
                <h3 className="text-xl font-logoSans text-ivory mb-4">Acceptance of Terms</h3>
                <p className="leading-relaxed">
                  By accessing and using Billy's WingCo services, you accept and agree to be bound by the 
                  terms and provision of this agreement.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-logoSans text-ivory mb-4">Use of Services</h3>
                <ul className="space-y-2 leading-relaxed">
                  <li>• You must be 18 years or older to place orders containing alcohol</li>
                  <li>• All menu prices are subject to change without notice</li>
                  <li>• We reserve the right to refuse service to anyone</li>
                  <li>• Delivery areas and times are subject to availability</li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-xl font-logoSans text-ivory mb-4">Payment Terms</h3>
                <p className="leading-relaxed">
                  Payment is due at the time of order. We accept cash, credit cards, and debit cards. 
                  For catering orders, a deposit may be required.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-logoSans text-ivory mb-4">Limitation of Liability</h3>
                <p className="leading-relaxed">
                  Billy's WingCo shall not be liable for any indirect, incidental, special, consequential, 
                  or punitive damages resulting from your use of our services.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-logoSans text-ivory mb-4">Contact Information</h3>
                <p className="leading-relaxed">
                  Questions about the Terms of Service should be sent to us at 
                  <span className="text-neonRed"> legal@billyswingco.com</span> or 
                  <span className="text-neonRed"> (416) 265-9223</span>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 